import { render, staticRenderFns } from "./PrincipalMessage.vue?vue&type=template&id=3f054a3e"
import script from "./PrincipalMessage.vue?vue&type=script&lang=js"
export * from "./PrincipalMessage.vue?vue&type=script&lang=js"
import style0 from "./PrincipalMessage.vue?vue&type=style&index=0&id=3f054a3e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports